module.exports = __webpack_public_path__ + "img/zip.8214ff1b.png";